<template>
	<div id="train">
    <div id="Return_Bar">
        <i class="el-icon-arrow-left"></i>
        <div @click="isreturn" class="isreturn">返回</div>
   
    </div>
    <div id="text">
    <div class="boxstyle">
    </div>
        <iframe :src="urlLink" scrolling="auto" frameborder="0" class="frame">
        </iframe>
	</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.query.id, //技能提升-场景id
      courseId: this.$route.query.courseId, //课程id
      type: this.$route.query.type, //上级tab类型
      tabMajorId: this.$route.query.tabMajorId, //上级tab的id
      majorId: this.$route.query.majorId, //
      lastCourseId: null, //上一课程id
      nextCourseId: null, //下一课程id
      readTimeSeconds: null, //pdf最少阅读时间
      nextExamCourse: false, //下一课是否测试课程
      urlLink:this.$route.query.urlLink,
      isReture:this.$route.query.isReture//是否是服务台跳回
    }
  },
  components: {

  },
  created() {
      this.urlLink =this.$route.query.urlLink;
  },
  mounted() {
      this.urlLink =this.$route.query.urlLink;
  },

  methods: {
     // 返回按钮
    isreturn(){
          this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk",{courseId:this.courseId})
        .then(
          (res) => {

            var result = res.data;

            if (result.success) {
               if(this.isReture=='yes'){
                 this.$router.go(-1)
               }else{
                   if(result.data.knowledgeRecordFullList.length!=1 && result.data.knowledgeRecordFullList.length!=0) {
                 this.$router.push({path:'/train/Secondarylist',query:{courseId:this.courseId,CourseLevel:this.$route.query.CourseLevel,
                 sceneId:this.$route.query.sceneId,
                  trainId:this.$route.query.trainId,
                  tjkId:this.$route.query.tjkId,
                  assitantTjkId:this.$route.query.tjkId
                 }})
             }else if(this.CourseLevel==3){
               this.$router.push({
                 path:'/train/SpecialCourses',query:{
                  sceneId:this.$route.query.sceneId,
                  trainId:this.$route.query.trainId,
                  tjkId:this.$route.query.tjkId,
                  assitantTjkId:this.$route.query.tjkId

                  }
                })
              }else{
               this.tabIndex=localStorage.getItem('tabIndex')

            this.$router.push({
              path:'/train/index',
              query:{
              tabIndex:this.tabIndex,
              condition:true//判断是否是基础知识点跳课程
              }
            })
             }
               }
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
  }
}
</script>

<style lang="less" scoped>
#train{padding: 0;}
#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
}
/deep/.el-icon-arrow-left {
  margin-top: 5px;
}
#text {
  background: #f6f5f8;
  width: 100%;
  padding: 20px 20px;
}
.isreturn{color:#000;cursor: pointer;}
.boxstyle{display: flex;justify-content: space-between;margin: 10px 0;}
.timestyle{margin: 0 20px;height: 28px;line-height: 28px;}
/deep/.el-dialog{border-radius: 10px;} 
/deep/.el-dialog__header{border-bottom: 1px solid #E9E9E9;}
/deep/.el-dialog__title {font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #262626;}
.currency_img{width: 85px;height: 64px;margin: 0 auto;margin-bottom: 12px;}
.currency_img>img{width:100%;height:100%;}
.currency_text{text-align: center;font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #262626;line-height: 20px;}
.currency_text>span{color: #497AF2}
.cancel{width: 80px;height: 28px;background: #E1E1E1;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #717171;text-align: center;line-height: 28px;margin-right: 10px;}
.determine{width: 80px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;text-align: center;line-height: 28px;cursor: pointer;}
.currency_button{display: flex;justify-content: center;}
.left_span{color: #497AF2;}
.otherdetermine{padding:0px 15px 0px 15px;height: 33px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;text-align: center;line-height: 33px;cursor: pointer;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/webPageLink.vue